import React from 'react';

export const Send = () => (<svg
        width='15'
        height='14'
        viewBox='0 0 15 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M1.37583 0.059605C1.14427 -0.0507817 0.868438 -0.00512117 0.684796 0.173999C0.501154 0.353119 0.448633 0.627724 0.553213 0.86197L3.16067 6.70231L0.553165 12.5458C0.448629 12.78 0.501204 13.0546 0.684882 13.2337C0.86856 13.4128 1.1444 13.4584 1.37594 13.348L14.1436 7.25854C14.2264 7.2204 14.2997 7.16421 14.358 7.09436C14.4085 7.03378 14.4478 6.96294 14.4721 6.88471C14.4904 6.82624 14.5 6.76476 14.5 6.70221C14.5 6.63967 14.4904 6.57818 14.4721 6.51971C14.4477 6.44148 14.4085 6.37065 14.3579 6.31008C14.3161 6.25991 14.2659 6.21601 14.2085 6.18071C14.1876 6.16784 14.1659 6.15621 14.1435 6.1459L1.37583 0.059605ZM11.1801 6.08991L2.34895 1.88017L4.22842 6.08991H11.1801ZM4.22851 7.31458H11.1813L2.34872 11.5272L4.22851 7.31458Z'
            fill='#6C6D70'
        />
    </svg>);
